export default __webpack_public_path__ + "static/media/verified-white.805cee78.svg";